import { Box, ListItem, styled, Typography } from '@mui/material';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottomWidth: 1,
  borderBottomStyle: 'solid',
  borderColor: theme.palette.grey[700],
  paddingBlock: theme.spacing(2),
}));
StyledListItem.defaultProps = {
  disablePadding: true,
};

export const StyledListItemContent = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledTypography = styled(Typography)({
  fontSize: 12,
  fontWeight: 700,
});
StyledTypography.defaultProps = {
  variant: 'body1',
};
